import React, { useState, useEffect } from "react";
import "./orderDispactherNote.scss";
import { Typography, Card, Input, Form, Select, Button } from "antd";
import { SendOutlined  } from "@ant-design/icons";
import moment from "moment";
import * as orderManagementActions from "../../../../../redux/actions/orderManagement.actions";
import * as dispatcherNotesActions from "../../../../../redux/actions/dispactherNote.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Search } = Input;
const { Title } = Typography;

const OrderDispactherNote = (props) => {
  const [dispacthNote, setDispacthNote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [noteListItems, setNoteListItems] = useState(false);
  var _ = require('lodash');
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.pageorderid){dispacthNoteList()}
  }, [props.pageorderid])

  const dispacthNoteList = async () => {
    try {
      setLoading(true);
      await props.dispatcherNotesActions.dispactherNoteListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (props.dispactherNoteData){
      const notelist = [];
      props.dispactherNoteData.map((item)=>{return notelist.push({value: item.slug,label: item.value})})
      setNoteListItems(notelist)
    }
  }, [props.dispactherNoteData])
  

  let hcNote = "";
  let hcComment = "";
  const handleChangenote = (e) => {
    e !== undefined ? hcNote = e: hcNote = ""
    handleDisableBtn()
  };
  const handleChangecomment = (e) => {
    hcComment = e
    handleDisableBtn()
  };
  const handleDisableBtn = () => {
    if (hcNote.length === 0 && hcComment.length === 0){
      setIsDisable(false)      
    } else {
      setIsDisable(true)
    }
  }

  useEffect(() => {
    if (props.orderData && props.orderData[0].dispatcher_notes){
      setDispacthNote(_.orderBy(Object.values(props.orderData[0].dispatcher_notes), ["createdAt"], ['desc']));
    }
  }, [props.orderData]);

  const onFinish = async (values) => {

    values.note = ''
    noteListItems.forEach(item => {
      if(item.value === values.slug){
        values.note = item.label
      }
    });

    const data = {
      note: values.comment && values.note ? 
      values.note+" || "+values.comment 
      :
      (values.comment && !values.note ? values.comment :
      !values.comment && values.note ? values.note : ""),
      slug: values.slug
    }
    try {
      setLoading(true);
      await props.orderManagementActions.orderDispactherNoteAction(props.pageorderid, data);
    } catch (e) {

    } finally {
      props.postListsrefresh();
      setLoading(false);
      form.resetFields();
    }
  }
  
  return (
    <Card title="Dispatcher Notes" bordered className="dispatcher-note">
      <div className="dn-body">
      {dispacthNote && dispacthNote.length !== 0 ?
        dispacthNote && dispacthNote.map((item)=>{
          return <div className="dnb-rep"><div>{item.note} <br />- by {item.user} at {moment(item.createdAt).format("DD MMMM, yyyy, h:mm:ss A")}</div><div></div></div>
          // return <div className="dnb-rep"><div>{item.note} <br /> -- by {item.user} at {moment(item.createdAt).format("h:mm A")}</div><div>{moment(item.createdAt).format("h:mm A")}</div></div>
        })
      : <div className="dnb-nts-rep"><Title level={3} disabled>Nothing to see</Title></div>}
      </div>
      {/* <Search loading={loading} disabled={loading} allowClear placeholder="Add note" enterButton={<SendOutlined />} onSearch={onFinish} style={{maxWidth: '100%',}}/> */}
      <Form form={form} onFinish={onFinish} layout="horizontal" loading={loading}>
        <Form.Item name={["slug"]} initialValue={""}>
          <Select allowClear options={noteListItems} onChange={(e)=>handleChangenote(e)} />
        </Form.Item>
        <Form.Item name={["comment"]} initialValue={""}>
          <Input placeholder="Add note" allowClear onChange={(e)=>handleChangecomment(e.target.value)} />
        </Form.Item>
        <Button className="submit" htmlType="submit" disabled={isDisable === false}><SendOutlined /></Button>
      </Form>
    </Card>
  );
};
const mapStateToProps = (state) => {
  return {
    taskDetailData: state.OrderManagementReducer.taskDetailData,
    dispactherNoteData: state.DispactherNoteReducer.dispactherNoteData,
    emailUser: state.authReducer.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
    dispatcherNotesActions: bindActionCreators(dispatcherNotesActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderDispactherNote);